import { z } from "zod";
export const signContractSchema = z.object({
    signature: z.string().min(1),
});
